// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"32e8bb71","51":"0ae02586","453":"12c2ab11"}[chunkId] + ".chunk.js";
};